module.exports = __webpack_public_path__ + "img/small-blue-half-circle.4358eca6.svg";